<script setup>
import KanbanCard from '../cards/KanbanCard.vue';

const props = defineProps({
  title: { type: String, required: true },
  statusValue: { type: String, required: true },
  iconClass: { type: String, default: '' },
  headerColor: { type: String, default: '#6C757D' },
  tasks: { type: Array, default: () => [] }
});

const emit = defineEmits(['create-task', 'select-task', 'dragstart', 'drop-status']);

const onDragOverColumn = (event) => {
  event.preventDefault();
};
</script>

<template>
  <div class="board-column" @dragover.prevent="onDragOverColumn" @drop="emit('drop-status', statusValue)">
    <div class="d-flex align-items-center justify-content-between mb-3 px-1">
      <span class="column-header-text" :style="{ color: headerColor }">
        <i :class="[iconClass, 'mr-1']"></i> {{ title }}
      </span>
      <button type="button" class="btn-add-task-icon" @click="emit('create-task', statusValue)" title="Nova tarefa">
        <i class="fa-solid fa-plus"></i>
      </button>
    </div>

    <div class="kanban-task-list">
      <transition-group name="move" tag="div">
        <KanbanCard
          v-for="(task, index) in tasks"
          :key="task.id || index"
          :task="task"
          :show-date="true"
          @select="emit('select-task', $event)"
          @dragstart="emit('dragstart', $event)"
        />
      </transition-group>
    </div>
  </div>
</template>

<style scoped>
.board-column {
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 12px;
  flex: 1;
  min-width: 250px;
  min-height: 680px;
  background-color: #E9ECEF;
}

.column-header-text {
  font-size: 14px;
  font-weight: 700;
}

.btn-add-task-icon {
  background: transparent;
  border: none;
  color: #6C757D;
  font-size: 14px;
  cursor: pointer;
  padding: 2px;
  transition: color 0.15s;
}

.btn-add-task-icon:hover {
  color: #F1860B;
}

.move-enter-active, .move-leave-active {
  transition: transform 0.25s ease, opacity 0.25s ease;
}

.move-enter, .move-leave-to {
  transform: translateY(20px);
  opacity: 0;
}
</style>